import api from './api';

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window;
}

export function isStandalone() {
  return window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
}

export async function registerPush() {
  if (!isPushSupported()) throw new Error('Push not supported');

  // Register service worker
  const registration = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;

  // Get VAPID key
  const { data } = await api.get('/api/push/vapid-key');
  const publicKey = data.publicKey;

  // Convert VAPID key to Uint8Array
  const padding = '='.repeat((4 - publicKey.length % 4) % 4);
  const base64 = (publicKey + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const applicationServerKey = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) applicationServerKey[i] = raw.charCodeAt(i);

  // Subscribe
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey
  });

  // Send subscription to server
  const subJson = subscription.toJSON();
  await api.post('/api/push/subscribe', {
    endpoint: subJson.endpoint,
    keys: subJson.keys
  });

  return subscription;
}

export async function unregisterPush() {
  if (!isPushSupported()) return;

  const registration = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!registration) return;

  const subscription = await registration.pushManager.getSubscription();
  if (subscription) {
    const endpoint = subscription.endpoint;
    await subscription.unsubscribe();
    await api.post('/api/push/unsubscribe', { endpoint });
  }
}

export async function getCurrentSubscription() {
  if (!isPushSupported()) return null;

  const registration = await navigator.serviceWorker.getRegistration('/sw.js');
  if (!registration) return null;

  return registration.pushManager.getSubscription();
}
